import { render, staticRenderFns } from "./Sitebar.vue?vue&type=template&id=0f99183e"
import script from "./Sitebar.vue?vue&type=script&lang=js"
export * from "./Sitebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports